import { FormFieldType, FormGroupDirectionType, IFormGroupConfig } from '@shared/ui';
import { passwordsValidator } from '@shared/core';

export const confirmPasswordFormConfig: IFormGroupConfig = {
  type: FormFieldType.GROUP,
  direction: FormGroupDirectionType.COLUMN,
  fields: {
    password: {
      type: FormFieldType.PASSWORD,
      placeholder: 'Создайте новый пароль',
      hideLabel: true,
      required: true,
      validators: [passwordsValidator],
    },
    confirmPassword: {
      type: FormFieldType.PASSWORD,
      placeholder: 'Введите пароль повторно',
      hideLabel: true,
      required: true,
      validators: [passwordsValidator],
    },
  },
};
